module.exports = __webpack_public_path__ + "img/RelianceBigTv.061dd8ee.png";